export default __webpack_public_path__ + "static/media/Axe_3.e94c4b38.png";